<template>
    <div class="register-wrapper">
        <div class="login-container">
            <h1>{{ $t("CreateAccount") }}</h1>
            <form v-if="this.$store.state.auth == 0" @submit.prevent="sendEmail" @keydown="formEmail.onKeydown($event)">
                <input type="email" autocomplete="false" v-model="formEmail.email" placeholder="example@gmail.com"
                    required />
                <div v-if="validateMessage != ''" style="text-align: center; margin-top: 10px">
                    <span style="color: red; margin: 0">{{ validateMessage }}*</span>
                </div>


                <button type="submit" class="signin" style="margin-top: 25px;" :disabled="formEmail.busy">{{
                    $t("continue") }} <i class="fa fa-spinner fa-spin " v-if="loading_register"></i></button>
            </form>
            <form v-else @submit.prevent="sendPhone" @keydown="formphone.onKeydown($event)">
                <input type="text" autocomplete="false" v-model="formphone.basic_phone" placeholder="xxxx xxxx"
                    :minlength=$store.state.country_length :maxlength=$store.state.country_length required />
                <span class="flag">
                    <h2>{{ $store.state.country_code }}</h2>
                    <img :src="this.$store.state.country_flag">
                </span>
                <div v-if="validateMessage != ''" style="text-align: center; margin-top: 10px">
                    <span style="color: red; margin: 0">{{ validateMessage }}*</span>
                </div>


                <button type="submit" class="signin" style="margin-top: 25px;" :disabled="formphone.busy">{{
                    $t("continue") }} <i class="fa fa-spinner fa-spin " v-if="loading_register"></i></button>
            </form>

        </div>
    </div>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import Form from "vform";

export default {
    components: { VuePhoneNumberInput },
    data: function () {
        return {
            isValid: false,
            partphone: null,
            validateMessage: "",
            formphone: new Form({
                phone: null,
                basic_phone: this.$localStorage.get(this.$store.register_phone),

            }),

            formEmail: new Form({
                email: this.$localStorage.get(this.$store.register_email),
                phone: null,
            }),
            loading_register:false,
        };
    },
created(){  this.$store.state.showHeader = true;
        this.$store.state.showFooter = true;},

    methods: {

        async sendEmail() {
            //if (this.isValid == true) {
            this.loading_register=true;
            this.$localStorage.set(
                this.$store.register_email,
                this.formEmail.email
            );
            await this.formEmail
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/genret_code/byemail",
                    {
                        email: this.formEmail.email,
                        //country: this.form.country,
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    this.loading_register=false;
                    if (response.data.code == "-1") {
                        console.log(response.data.code);
                        this.validateMessage = response.data.message;
                        setTimeout(() => {
                            this.validateMessage = "";
                        }, 3000);
                    } else if (response.data.code == "1") {
                        this.$router.push({
                            name: "activateCode",
                            params: {
                                storeName: this.$store.storeName,
                                email: this.formEmail.email,
                                lang: this.$i18n.locale
                            }
                        });

                    }
                });

        }


        ,



        async sendPhone() {
            this.loading_register=true;
            this.formphone.phone = this.$store.state.country_code + this.formphone.basic_phone
            this.$localStorage.set(
                this.$store.register_phone,
                this.formphone.basic_phone
            );

            await this.formphone
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/genret_code",
                    {
                        phone: this.formphone.phone,
                        //country: this.form.country,
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    this.loading_register=false;
                    if (response.data.code == "-1") {
                        this.formphone.phone = null;
                        console.log(response.data.code);
                        this.validateMessage = response.data.message;
                        setTimeout(() => {
                            this.validateMessage = "";
                        }, 3000);
                    } else if (response.data.code == "1") {
                        this.$router.push({
                            name: "activateCode",
                            params: {
                                storeName: this.$store.storeName,
                                phone: this.formphone.phone,
                                lang: this.$i18n.locale
                            }
                        });

                    }
                });

        }




    }
};
</script>